const templates = {
  title: 'Templates',
  create: 'Create Template',
  edit: 'Edit Template',
  duplicate: 'Duplicate',
  duplicateTemplate: 'Duplicate Template',
  templateDuplicated: 'Template duplicated',
  templateName: 'Template Name',
  templateFile: 'Template File',
  templateNamePlaceholder: 'SOAP Note, Initial Consultation',
  templateLanguage: 'Template Language',
  sections: 'Sections',
  addSection: 'Add Section',
  sectionTitle: 'Section Title',
  sectionTitlePlaceholder: 'Subjective, Assessment, Plan',
  sectionInstructions: 'AI Instructions',
  sectionInstructionsPlaceholder:
    'Instructions for what this section should contain...',
  save: 'Save',
  templateCreated: 'Template created',
  cancel: 'Cancel',
  noSections: 'No sections yet. Add your first section to get started.',
  noTemplates: 'No templates yet',
  noTemplatesDescription: 'Create your first template to get started.',
  section_one: '{{count}} section',
  section_other: '{{count}} sections',
  publicTemplate: 'Public Template',
  publicTemplateDescription: 'Make this template visible to all users',
  personalTemplates: 'My Templates',
  publicTemplates: 'Public Templates',
  separator: ' • ',
  loading: 'Loading...',
  templateUpdated: 'Template updated',
  invalidTemplateId: 'Invalid template ID',
  templateNotFound: 'Template not found',
  validation: {
    templateNameRequired: 'Template name is required',
    languageRequired: 'Template language is required',
    atLeastOneSectionRequired: 'At least one section is required',
    onlyDocxFilesAllowed: 'Only DOCX files are allowed',
    sectionTitleRequired: 'Section title is required',
    sectionInstructionsRequired: 'Section instructions are required',
    fileRequired: 'File is required',
  },
  public: 'Public',
  private: 'Private',
  collapse: 'Collapse',
  expandAll: 'Expand All',
  collapseAll: 'Collapse All',
  deleteConfirmTitle: 'Delete Template',
  deleteConfirmDescription:
    'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  delete: 'Delete',
};

export default templates;
